<script lang="ts">
  import { avatarColor, initials } from '$lib/utils/avatar';

  const { id, name, size = 26 }: { id: number; name: string; size?: number } = $props();
</script>

<span
  class="av"
  title={name}
  style="width:{size}px;height:{size}px;background:{avatarColor(id)};font-size:{Math.round(size * 0.4)}px"
>
  {initials(name)}
</span>
